module.exports = __webpack_public_path__ + "share_trans.32cf6b1c.png";